import { createContext } from 'react';
import type { GroupedWorkspaceConfigModel } from '@r/api/generated/client.schemas.ts';

const WorkspaceConfigContext = createContext<GroupedWorkspaceConfigModel | undefined>(undefined);

export { WorkspaceConfigContext };
